import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, MapPin, Phone, Mail, Clock } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export const Footer = () => {
  const { settings } = useStore();
  return (
    <footer className="bg-brand-blue text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-10 h-10 flex items-center justify-center bg-brand-gold border-2 border-black rounded-md">
              <BookOpen className="w-5 h-5 text-brand-blue" strokeWidth={2.5} />
            </span>
            <span className="font-display font-black text-2xl">
              Books<span className="text-brand-gold">N</span>more
            </span>
          </div>
          <p className="text-white/70 max-w-md leading-relaxed">
            {settings?.tagline ||
              "Your one-stop shop for books, stationery & more in Abeokuta."}
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-brand-gold mb-4">Explore</h4>
          <ul className="space-y-2 text-white/80">
            <li><Link to="/shop" className="hover:text-brand-gold">Shop</Link></li>
            <li><Link to="/about" className="hover:text-brand-gold">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-brand-gold">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-brand-gold mb-4">Visit / Call</h4>
          <ul className="space-y-3 text-white/80 text-sm">
            {settings?.address && (
              <li className="flex gap-2"><MapPin className="w-4 h-4 mt-0.5 text-brand-gold shrink-0" /> {settings.address}</li>
            )}
            {settings?.phone && (
              <li className="flex gap-2"><Phone className="w-4 h-4 mt-0.5 text-brand-gold shrink-0" /> <a href={`tel:${settings.phone}`} className="hover:text-brand-gold">{settings.phone}</a></li>
            )}
            {settings?.email && (
              <li className="flex gap-2"><Mail className="w-4 h-4 mt-0.5 text-brand-gold shrink-0" /> <a href={`mailto:${settings.email}`} className="hover:text-brand-gold">{settings.email}</a></li>
            )}
            {settings?.hours && (
              <li className="flex gap-2"><Clock className="w-4 h-4 mt-0.5 text-brand-gold shrink-0" /> {settings.hours}</li>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15 py-5 text-center text-white/60 text-sm">
        &copy; {new Date().getFullYear()} BooksNmore, Abeokuta. All rights reserved.
      </div>
    </footer>
  );
};
